// extracted by mini-css-extract-plugin
export default {"section":"NovelListSection_section__pmmt6","list":"NovelListSection_list__jCpwQ"};